import { useMutation } from "@1f/react-sdk";
import { mutation_update_tenant } from "../mutations/tenantMutations";
import { Tenanthelpers } from "../helpers/tenantHelpers";

export const TenantApi = () => {
    const apiUpdateTenant = useMutation(mutation_update_tenant, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const { CreateTenantModel } = Tenanthelpers();

    const UpdateTenantAndGetModel = async (tenantData) => {
        try {
            let tenantUpdateResponse = await apiUpdateTenant.fetch({
                tenantId: tenantData.tenantId,
                name: tenantData.name,
                identifier: tenantData.identifier,
                vatNumber: tenantData.vatNumber,
                addrStreetName: tenantData.addrStreetName,
                addrStreetNumber: tenantData.addrStreetNumber,
                addrCity: tenantData.addrCity,
                addrProvince: tenantData.addrProvince,
                addrZipCode: tenantData.addrZipCode,
                addrCountry: tenantData.addrCountry,
                addrFull: tenantData.addrFull,
                classifier: tenantData.classifier,
            });
            const result = tenantUpdateResponse.data.data.update_tenant.returning;
            
            if(result.length > 0){
                return CreateTenantModel(result[0]);
            }
        } catch (error) {
            throw new Error("Errore durante l'aggiornamento del tenant sul DB: " + error.message);
        }
    }

    return {
        UpdateTenantAndGetModel
    }
}